import gql from 'graphql-tag';

export const CandidacyListQuery = gql`
	query CandidacyListQuery(
		$first: Int
		$cursor: String
		$orderBy: CandidacyOrderBy
		$orderDesc: Boolean
		$filter: CandidacyFilterInput
	) {
		entities: candidacies(
			first: $first
			after: $cursor
			orderBy: $orderBy
			orderDesc: $orderDesc
			filter: $filter
		) {
			edges {
				node {
					id
					localId
					name
					Award {
						id
						localId
						name
						edition
						year
					}
					Company {
						id
						localId
						name
					}
					AwardCategory {
						id
						name
					}
				}
			}
			total
			pageInfo {
				hasNextPage
				hasPreviousPage
			}
		}
	}
`;


